import { useEffect, useRef, useState } from "preact/hooks";
import { messages, isThinking, customerName } from "../store";
import { Message } from "./Message";

const LOADING_QUOTES = [
  "Bygger en badstue …",
  "Fyrer i ovnen …",
  "Kraner badstuen på plass …",
  "Heller vann på steinene …",
  "Måler opp tomten …",
  "Sjekker leveringstid …",
  "Spør Mattis kjapt …",
  "Baserer det på at ventilasjonen er god …",
  "Pakker ut en Dice M …",
  "Velger riktig treverk …",
];

function randomQuote(exclude?: string): string {
  const pool = exclude
    ? LOADING_QUOTES.filter((q) => q !== exclude)
    : LOADING_QUOTES;
  return pool[Math.floor(Math.random() * pool.length)];
}

function IntroCard() {
  const greeting = customerName.value
    ? `Hei, ${customerName.value.split(" ")[0]}!`
    : "Hei!";
  return (
    <div class="ic-intro">
      <h3 class="ic-intro-title">{greeting} Jeg er Iskra.</h3>
      <p class="ic-intro-body">
        Badstuguttas digitale assistent. Spør om modeller, priser, levering
        eller montering, så svarer jeg med en gang.
      </p>
    </div>
  );
}

export function MessageList() {
  const ref = useRef<HTMLDivElement>(null);
  const [quote, setQuote] = useState(LOADING_QUOTES[0]);

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [messages.value.length, isThinking.value]);

  useEffect(() => {
    if (!isThinking.value) return;
    setQuote(randomQuote());
    const id = setInterval(() => {
      setQuote((current) => randomQuote(current));
    }, 2500);
    return () => clearInterval(id);
  }, [isThinking.value]);

  const hasUserMessage = messages.value.some((m) => m.role === "user");

  return (
    <div class="ic-body" ref={ref} role="log" aria-live="polite">
      {!hasUserMessage && <IntroCard />}
      {messages.value.map((msg, i) => (
        // ts i nøkkelen: svaret erstatter «Mottatt»-ack-et på samme indeks, og uten
        // den arvet svaret ack-ets tilstand (tomt e-postutkast).
        <Message key={`${i}-${msg.ts}`} msg={msg} />
      ))}
      {isThinking.value && (
        <div class="ic-msg ic-msg-iskra ic-thinking-bubble">
          <div class="ic-thinking">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="ic-thinking-quote" key={quote}>{quote}</div>
        </div>
      )}
    </div>
  );
}
